module.exports = __webpack_public_path__ + "img/surprise.afe5d584.png";